export const lockStates = Object.freeze({
  loading: 0,
  locked: 1,
  open: 2,
  willChangeToLocked: 3,
  willChangeToOpen: 4,
});
